import React from "react";
import PropTypes from "prop-types";
import SweetAlert from "react-bootstrap-sweetalert";
import classNames from "classnames";

import { makeStyles } from "@material-ui/core/styles";

import menuStyle from "assets/jss/material-dashboard-pro-react/views/menuStyle.js";

const useStyles = makeStyles(menuStyle);

export default function AlertMinTotal(props) {
  const { showAlert, updatePopUp, body, danger = true } = props;

  const classes = useStyles();

  const confirmClass = classNames({
    [classes.buttonAlert]: true,
    [classes.totalButton]: true
  });

  return (
    <>
      {showAlert ? (
        <SweetAlert
          success={false}
          danger={danger}
          customClass={classes.containerAlert}
          style={{
            padding: 0
          }}
          title={""}
          onConfirm={() => {
            updatePopUp(false);
          }}
          onCancel={() => {
          }}
          cancelBtnCssClass={`${classes.buttonAlert}`}
          confirmBtnCssClass={`${confirmClass}`}
          showCancel={false}
        >
          <div className={classes.containerAlertBody}>{body}</div>
        </SweetAlert>
      ) : null}
    </>
  );
}

AlertMinTotal.propTypes = {
  showAlert: PropTypes.bool.isRequired,
  updatePopUp: PropTypes.func.isRequired,
  body: PropTypes.any.isRequired
};
